import {
  EMPLOYEE_LIST_REQUEST,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAIL,
  EMPLOYEE_LIST_RESET,
  EMPLOYEE_LIST_SIMPLE_REQUEST,
  EMPLOYEE_LIST_SIMPLE_SUCCESS,
  EMPLOYEE_LIST_SIMPLE_FAIL,
  EMPLOYEE_LIST_SIMPLE_RESET,
  EMPLOYEE_CREATE_REQUEST,
  EMPLOYEE_CREATE_SUCCESS,
  EMPLOYEE_CREATE_FAIL,
  EMPLOYEE_CREATE_RESET,
  EMPLOYEE_DELETE_REQUEST,
  EMPLOYEE_DELETE_SUCCESS,
  EMPLOYEE_DELETE_FAIL,
  EMPLOYEE_DELETE_RESET,
  EMPLOYEE_DETAILS_REQUEST,
  EMPLOYEE_DETAILS_SUCCESS,
  EMPLOYEE_DETAILS_FAIL,
  EMPLOYEE_DETAILS_RESET,
  EMPLOYEE_UPDATE_REQUEST,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_RESET,
  EMPLOYEE_UPDATE_STATUS_REQUEST,
  EMPLOYEE_UPDATE_STATUS_SUCCESS,
  EMPLOYEE_UPDATE_STATUS_FAIL,
  EMPLOYEE_UPDATE_STATUS_RESET,
  EMPLOYEE_WORK_SCHEDULE_REQUEST,
  EMPLOYEE_WORK_SCHEDULE_SUCCESS,
  EMPLOYEE_WORK_SCHEDULE_FAIL,
  EMPLOYEE_WORK_SCHEDULE_RESET,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_RESET,
  EMPLOYEE_DOCUMENT_UPLOAD_REQUEST,
  EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS,
  EMPLOYEE_DOCUMENT_UPLOAD_FAIL,
  EMPLOYEE_DOCUMENT_UPLOAD_RESET,
  EMPLOYEE_DOCUMENT_DELETE_REQUEST,
  EMPLOYEE_DOCUMENT_DELETE_SUCCESS,
  EMPLOYEE_DOCUMENT_DELETE_FAIL,
  EMPLOYEE_DOCUMENT_DELETE_RESET,
} from "../constants/employeeConstants";

export const employeeListReducer = (
  state = {
    employees: [],
    countsByStatus: {},
    globalTotalCount: 0,
    countsByProfession: {},
    countsByGender: {},
    genderPercentages: {},
  },
  action
) => {
  switch (action.type) {
    case EMPLOYEE_LIST_REQUEST:
      return { loading: true, employees: [] };
    case EMPLOYEE_LIST_SUCCESS:
      return {
        loading: false,
        employees: action.payload.employees,
        pages: action.payload.pages,
        page: action.payload.page,
        countsByStatus: action.payload.countsByStatus,
        globalTotalCount: action.payload.globalTotalCount,
        countsByProfession: action.payload.countsByProfession,
        countsByGender: action.payload.countsByGender,
        genderPercentages: action.payload.genderPercentages,
      };
    case EMPLOYEE_LIST_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_LIST_RESET:
      return {
        employees: [],
        countsByStatus: {},
        globalTotalCount: 0,
        countsByProfession: {},
        countsByGender: {},
        genderPercentages: {},
      };
    default:
      return state;
  }
};

export const employeeListSimpleReducer = (
  state = { employees: [] },
  action
) => {
  switch (action.type) {
    case EMPLOYEE_LIST_SIMPLE_REQUEST:
      return { loading: true, employees: [] };
    case EMPLOYEE_LIST_SIMPLE_SUCCESS:
      return {
        loading: false,
        employees: action.payload.employees,
      };
    case EMPLOYEE_LIST_SIMPLE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_LIST_SIMPLE_RESET:
      return { employees: [] };
    default:
      return state;
  }
};

export const employeeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_CREATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_CREATE_SUCCESS:
      return { loading: false, success: true, employee: action.payload };
    case EMPLOYEE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DELETE_REQUEST:
      return { loading: true };
    case EMPLOYEE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDetailsReducer = (state = { employee: {} }, action) => {
  switch (action.type) {
    case EMPLOYEE_DETAILS_REQUEST:
      return { ...state, loading: true };
    case EMPLOYEE_DETAILS_SUCCESS:
      return { loading: false, employee: action.payload };
    case EMPLOYEE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DETAILS_RESET:
      return { employee: {} };
    default:
      return state;
  }
};

export const employeeUpdateReducer = (state = { employee: {} }, action) => {
  switch (action.type) {
    case EMPLOYEE_UPDATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_UPDATE_SUCCESS:
      return { loading: false, success: true, employee: action.payload };
    case EMPLOYEE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_UPDATE_RESET:
      return { employee: {} };
    default:
      return state;
  }
};

export const employeeUpdateStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_UPDATE_STATUS_REQUEST:
      return { loading: true };
    case EMPLOYEE_UPDATE_STATUS_SUCCESS:
      return { loading: false, success: true };
    case EMPLOYEE_UPDATE_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_UPDATE_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeWorkScheduleReducer = (state = { workSchedule: [] }, action) => {
  switch (action.type) {
    case EMPLOYEE_WORK_SCHEDULE_REQUEST:
      return { loading: true, workSchedule: [] };
    case EMPLOYEE_WORK_SCHEDULE_SUCCESS:
      return {
        loading: false,
        workSchedule: action.payload.workSchedule || [],
      };
    case EMPLOYEE_WORK_SCHEDULE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_WORK_SCHEDULE_RESET:
      return { workSchedule: [] };
    default:
      return state;
  }
};

export const employeeWorkScheduleUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST:
      return { loading: true };
    case EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        workSchedule: action.payload.workSchedule || [],
      };
    case EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_WORK_SCHEDULE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDocumentUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DOCUMENT_UPLOAD_REQUEST:
      return { loading: true };
    case EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS:
      return { loading: false, success: true, document: action.payload };
    case EMPLOYEE_DOCUMENT_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DOCUMENT_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

export const employeeDocumentDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case EMPLOYEE_DOCUMENT_DELETE_REQUEST:
      return { loading: true };
    case EMPLOYEE_DOCUMENT_DELETE_SUCCESS:
      return { loading: false, success: true, documentId: action.payload };
    case EMPLOYEE_DOCUMENT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case EMPLOYEE_DOCUMENT_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
